import { render } from "./PaymentSheet.vue?vue&type=template&id=5ae18eb8"
import script from "./PaymentSheet.vue?vue&type=script&lang=js"
export * from "./PaymentSheet.vue?vue&type=script&lang=js"

import "./PaymentSheet.vue?vue&type=style&index=0&id=5ae18eb8&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__